// extracted by mini-css-extract-plugin
module.exports = {"content":"AssignmentEvent_content__KMl9y","fullWidth":"AssignmentEvent_fullWidth__v3G7b","compact":"AssignmentEvent_compact__3alwL","alert":"AssignmentEvent_alert__1Awir"};